"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WhishlistValidationService = void 0;
var joi_1 = __importDefault(require("joi"));
var Result_1 = require("../../../../../models/concrete/Result");
var WhishlistValidationService = /** @class */ (function () {
    function WhishlistValidationService() {
        this.schemaForGetWishlistItems = joi_1.default.object().keys({
            extensions: joi_1.default.array().items().optional()
        });
        this.schemaForAddItemToWishlist = joi_1.default.object().keys({
            wishlistItemId: joi_1.default.number().required(),
        });
        this.schemaForRemoveItemFromWishlist = joi_1.default.object().keys({
            wishlistItemId: joi_1.default.number().required(),
        });
        this.schemaForClearWishlist = joi_1.default.object().keys({});
    }
    WhishlistValidationService.prototype.getWishlistItemsData = function (data) {
        var error = this.schemaForGetWishlistItems.validate(data).error;
        // debug
        console.debug('Validating get wishlist items data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    WhishlistValidationService.prototype.addItemToWishlistData = function (data) {
        var error = this.schemaForAddItemToWishlist.validate(data).error;
        // debug
        console.debug('Validating add item to wishlist data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    WhishlistValidationService.prototype.removeItemFromWishlistData = function (data) {
        var error = this.schemaForRemoveItemFromWishlist.validate(data).error;
        // debug
        console.debug('Validating remove item from wishlist data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    WhishlistValidationService.prototype.clearWishlistData = function (data) {
        var error = this.schemaForClearWishlist.validate(data).error;
        // debug
        console.debug('Validating clear cart data', JSON.stringify(data));
        if (error) {
            console.debug('Validation failed');
            console.debug(error.details[0].message);
            return Result_1.Result.fail(error.details[0].message);
        }
        else {
            console.debug('Validation went successful');
        }
        return Result_1.Result.ok('');
    };
    return WhishlistValidationService;
}());
exports.WhishlistValidationService = WhishlistValidationService;
//# sourceMappingURL=WhishlistValidationService.js.map